import React from 'react';
import TicketReply from '../ReusedComponents/TicketReply'
import { useParams, useHistory } from 'react-router-dom'

export default function UserReply() {
    const history = useHistory();
    const { sid, uid } = useParams();

    const state = history.location.state || {};
    // For head-office users the URL sid is the ticket's member-school id; the
    // head-office sid is carried in nav state so back-nav returns to the
    // aggregated head-office view. Falls back to the URL sid for normal users.
    const navSid = state.navSid || sid;

    return (
        <div className="totalTicketingModule">
            <TicketReply
                userType={state.userType || "User"}
                title={state.title || "Ticket Details"}
                options={[
                    { title: "Create ticket", url: `/tickets/user/creating/${navSid}/${uid}` },
                    { title: "Ticket reports", url: `/tickets/user/report/${navSid}/${uid}` },
                    { title: "Assigned Tickets", url: `/tickets/user/assigned_tickets/${navSid}/${uid}` }
                ]}
            />
        </div>
    )
}